export enum MembershipStatus {
	Pending,
	Active,
	Expired,
	Cancelled,
	Free,
	Archived,
	Interested,
	ForActivation
}
